import { styled, css } from "../../../styled-components";

export const Smartphone = styled.div<{
    round: number;
    isAIPlayer?: boolean;
    AIAccentColor?: string;
    width?: number;
    height?: number;
    scale?: number;
}>`
    position: relative;
    ${p =>
        css`
            border-radius: ${p.round}px;
        `}
    ${p =>
        p.isAIPlayer !== undefined && p.AIAccentColor
            ? `box-shadow: 0 0 0 5px #151515, 0 0 0 6px ${p.AIAccentColor}, 0 -7.5px 1.5px rgba(255, 255, 255, 0.4),
        7.5px 0 1.5px rgba(255, 255, 255, 0.25), -7.5px 0 1.5px rgba(255, 255, 255, 0.4),
        0 7.5px 1.5px rgba(255, 255, 255, 0.25), 0 0 0 9px ${p.AIAccentColor}, 6px 8px 16px rgba(0, 0, 0, 0.25),
        20px 32px 72px rgba(0, 0, 0, 0.2);`
            : `box-shadow: 0px 36px 42px rgba(0, 0, 0, 0.1)`};

    width: ${p => (p.width ? p.width : "375")}px; //375px; ${p => (p.isAIPlayer ? "270" : "375")}px;
    min-width: ${p => (p.width ? p.width : "375")}px; //${p => (p.isAIPlayer ? "270" : "375")}px;
    max-height: ${p => (p.height ? p.height : "812")}px; //812px;
    height: ${p => (p.height ? p.height + "px" : "100%")}; //${p => (p.isAIPlayer ? "590px" : "100%")};
    ${p => (p.scale ? `transform: scale(${p.scale})` : "transform: translate3d(0, 0, 0)")};
    overflow: hidden;

    #loader-1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
